// extracted by mini-css-extract-plugin
export default {"tabDashboardUsage":"TabTenantsUsage_tabDashboardUsage__xoTdp","rangeSelect":"TabTenantsUsage_rangeSelect__bHA0d","card":"TabTenantsUsage_card__IMWiW"};